import { firstValueFrom } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TimesheetObsService } from '@app/main/time-sheet-new/services/timesheet-obs.service';
import { NgxSpinnerTextService } from '@app/shared/ngx-spinner-text.service';
import { RightFlyoutOverlayService } from '@app/shared/common/right-flyout-overlay.service';
import { AppConsts } from '@shared/AppConsts';
import { ApiRenderFlushService } from '@shared/service-proxies/api-render-flush.service';
import { CompanyProfileServiceProxy, ProfileServiceProxy, SessionServiceProxy, TimesheetServiceProxy } from '@shared/service-proxies/service-proxies';
import { RootService } from '@root/root.service';
import { AppLoggerService } from '@shared/common/logging/app-logger.service';

@Component({
    standalone: false,
    selector: "app-root",
    template: ` <router-outlet></router-outlet>

    <ngx-spinner template=" " bdColor="rgba(0,0,0,0)" size="medium" color="#5ba7ea" type="ball-clip-rotate">
        <p>{{getSpinnerText()}}</p>
    </ngx-spinner> `,
})
export class RootComponent implements OnInit, OnDestroy {
    ngxSpinnerText: NgxSpinnerTextService;

    constructor(
        _ngxSpinnerText: NgxSpinnerTextService,
        private _companyProfileServiceProxy: CompanyProfileServiceProxy,
        private _tsProxy: TimesheetServiceProxy,
        private _sessionServiceProxy: SessionServiceProxy,
        private _rootService: RootService,
        private _profileService: ProfileServiceProxy,
        private _apiRenderFlushService: ApiRenderFlushService,
        _appLogger: AppLoggerService,
        private _rightFlyoutBlurService: RightFlyoutOverlayService
    ) {
        this.ngxSpinnerText = _ngxSpinnerText;
        this.setTimesheetPermissions();
        this.setDateFormat();
    }

    ngOnInit(): void {
        this._rightFlyoutBlurService.start();
    }

    ngOnDestroy(): void {
        this._rightFlyoutBlurService.stop();
    }

    getSpinnerText(): string {
        return this.ngxSpinnerText.getText();
    }

    async setDateFormat() {
        if (abp.session.userId == null) {
            return;
        }

        const tenantId = abp.session.tenantId ? abp.session.tenantId : undefined;
        const companyDetailsPromise = AppConsts.companyDetails
            ? Promise.resolve(AppConsts.companyDetails)
            : firstValueFrom(this._companyProfileServiceProxy.getCompanyProfileDetailsForEditView(tenantId));
        const myProfileInfoPromise = AppConsts.myProfileInfo
            ? Promise.resolve(AppConsts.myProfileInfo)
: firstValueFrom(this._profileService.myProfileInfo());

        const [companyDetails, myProfileInfo] = await Promise.all([companyDetailsPromise, myProfileInfoPromise]);

        AppConsts.companyDetails = companyDetails;
        AppConsts.dateFormatId = AppConsts.dateFormatId || AppConsts.companyDetails?.dateFormat;

        if (myProfileInfo) {
            AppConsts.myProfileInfo = myProfileInfo;
            localStorage.setItem('MyProfileData', JSON.stringify(myProfileInfo));
        }
    }

    async setTimesheetPermissions() {
        //if (abp.session.userId != null) {          
        //    AppConsts.isCurrentUserTimesheetApprover = await firstValueFrom(this._tsProxy.isTimeSheetApprovar(abp.session.userId));
        //}
        // Commented to remove the duplicate API call getCurrentLoginInformations()

        // AppConsts.userRoleArray = (await firstValueFrom(this._sessionServiceProxy.getCurrentLoginInformations())).user?.userRole.map((r) =>
        //     r.toLowerCase()
        // );
        // if (AppConsts.userRoleArray) 
            this._rootService.timesheetPersmissionInfoSet.next(1);
    }
}
